import React from "react";
import PropTypes from "prop-types";
import { FeaturesProvider } from "contexts/FeaturesContext";
import { UserProfileProvider } from "contexts/UserProfileContext";

/** Wrapper provider which setups user profile, entitlement and feature contexts */
export const PermissionsProvider = ({ children }) => {
  return (
    <UserProfileProvider>
      <FeaturesProvider>{children}</FeaturesProvider>
    </UserProfileProvider>
  );
};

PermissionsProvider.propTypes = {
  children: PropTypes.node
};
